import React from 'react'
import { Outlet } from 'react-router-dom'

import AppHeader from '@components/appHeader/AppHeader.component'

const Layout: React.FC = () => {
    return (
        <>
            <AppHeader />
            <Outlet />
        </>
    )
}

export default Layout
